import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/(sub-layout)/king/@section6/page.tsx");
